module.exports = __webpack_public_path__ + "media/images/icons/warning-b2983752b6d1bb4c568ad2b15624083e.svg";